import { render } from "./MoneyHubCallbackPage.vue?vue&type=template&id=26bf8579&scoped=true"
import script from "./MoneyHubCallbackPage.vue?vue&type=script&lang=js"
export * from "./MoneyHubCallbackPage.vue?vue&type=script&lang=js"

import "./MoneyHubCallbackPage.vue?vue&type=style&index=0&id=26bf8579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bf8579"]])

export default __exports__